var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[(_vm.processing)?_c('div',[_vm._v("Processing...")]):_c('div',[_vm._v("Login success. Please close this tab")])])
}
var staticRenderFns = []

export { render, staticRenderFns }